const STRING_CONSTANTS = {
  SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN: 'Something went wrong. Please try again',
};

const COLORS = {
  plum: '#9A4C95',
  errorColor: '#e64545',
  darkerGray: '#717171',
};

const enum SERVER_ERROR_CODES {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  LIMIT_FILE_SIZE = 'LIMIT_FILE_SIZE',
}

export { STRING_CONSTANTS, COLORS, SERVER_ERROR_CODES };
